var path = '/var/www/mmscny-cms/src/app/common/components/days-of-operation/days-of-operation.html';
var html = "<div class=\"col-md-12 col-xs-12 col-sm-12 col-lg-12 days-of-operation\"> <h4 class=text-capitalize>days <span class=text-lowercase>of</span> operation</h4> <ul> <li ng-class=\"$ctrl._getClass('monday')\">M</li> <li ng-class=\"$ctrl._getClass('tuesday')\">T</li> <li ng-class=\"$ctrl._getClass('wednesday')\">W</li> <li ng-class=\"$ctrl._getClass('thursday')\">T</li> <li ng-class=\"$ctrl._getClass('friday')\">F</li> <li ng-class=\"$ctrl._getClass('saturday')\">S</li> <li ng-class=\"$ctrl._getClass('sunday')\">S</li> </ul> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/days-of-operation/days-of-operation.html
// module id = 718
// module chunks = 0